import { render, staticRenderFns } from "./WorkflowDetail.vue?vue&type=template&id=aab8ba30&"
import script from "./WorkflowDetail.vue?vue&type=script&lang=js&"
export * from "./WorkflowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports